// extracted by mini-css-extract-plugin
module.exports = {"next-sr-only":"EditOrFinishFreeze--next-sr-only--3E7uFYL","footerButtonContainer":"EditOrFinishFreeze--footerButtonContainer--yvO0h28"};